import styled from 'styled-components';
import { createStyles, makeStyles, Button } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    mb15: {
      'margin-bottom': '15px'
    }
  })
);

export const SignInButton = styled(Button)`
  color: #6e84a3;
  font-size: 15px;
  font-family: 'TTCommons';
  text-transform: none;
  line-height: 17px;
  padding: 7px 10px;
`;

export const RegisterButton = styled(Button)`
  color: #ffffff;
  font-size: 15px;
  font-family: 'TTCommons';
  text-transform: none;
  line-height: 17px;
  padding: 10px;
  height: 31px;
`;
